export default "__VITE_ASSET__38624869__"